var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"has-text-centered"},[_c('i',{staticClass:"fa fa-plus bottom20 top8"})])])
}]

export { render, staticRenderFns }